<template>
  <div class="tags-view-container">
    <el-scrollbar class="tags-view-wrapper" ref="scrollbar">
      <span
        v-for="tag in visitedViews"
        :key="tag.path"
        :class="['tags-view-item', { active: isActive(tag) }]"
        @click="openTab(tag)"
      >
        <span class="tags-view-item-title">{{ tag.title }}</span>
        <i
          v-if="!isAffix(tag)"
          class="el-icon-close tags-view-item-close"
          @click.stop="closeTab(tag)"
        />
      </span>
    </el-scrollbar>
    <div class="tags-view-actions">
      <el-dropdown trigger="click" @command="handleCommand">
        <span class="tags-view-dropdown">
          <i class="el-icon-arrow-down" />
        </span>
        <el-dropdown-menu slot="dropdown" size="small">
          <el-dropdown-item command="closeOthers">关闭其他</el-dropdown-item>
          <el-dropdown-item command="closeAll">关闭所有</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

const AFFIX_PATHS = ['/home/index']

export default {
  name: 'TagsView',
  computed: {
    ...mapState('tagsView', ['visitedViews']),
  },
  watch: {
    $route() {
      this.scrollToActiveTab()
    },
    visitedViews() {
      this.$nextTick(() => {
        this.scrollToActiveTab()
      })
    },
  },
  methods: {
    isActive(tag) {
      return tag.path === this.$route.path
    },
    isAffix(tag) {
      return AFFIX_PATHS.includes(tag.path)
    },
    openTab(tag) {
      if (tag.path === this.$route.path) return
      this.$router.push({
        path: tag.path,
        query: tag.query,
        params: tag.params,
      })
    },
    async closeTab(tag) {
      const visitedViews = await this.$store.dispatch('tagsView/delView', tag)
      if (this.isActive(tag)) {
        const lastView = visitedViews[visitedViews.length - 1]
        if (lastView) {
          this.$router.push({
            path: lastView.path,
            query: lastView.query,
            params: lastView.params,
          })
        } else {
          this.$router.push('/home/index')
        }
      }
    },
    handleCommand(command) {
      const activeTag = this.visitedViews.find(
        (v) => v.path === this.$route.path
      )
      if (!activeTag) return
      if (command === 'closeOthers') {
        this.$store.dispatch('tagsView/delOthersViews', activeTag)
      } else if (command === 'closeAll') {
        this.$store.dispatch('tagsView/delAllViews').then((visitedViews) => {
          const lastView = visitedViews[visitedViews.length - 1]
          if (lastView) {
            this.$router.push({
              path: lastView.path,
              query: lastView.query,
              params: lastView.params,
            })
          } else {
            this.$router.push('/home/index')
          }
        })
      }
    },
    scrollToActiveTab() {
      this.$nextTick(() => {
        const container = this.$el.querySelector('.el-scrollbar__wrap')
        if (!container) return
        const activeItem = this.$el.querySelector('.tags-view-item.active')
        if (!activeItem) return
        const offsetLeft = activeItem.offsetLeft
        const containerWidth = container.offsetWidth
        const scrollLeft = container.scrollLeft
        if (offsetLeft < scrollLeft) {
          container.scrollLeft = offsetLeft
        } else if (
          offsetLeft + activeItem.offsetWidth >
          scrollLeft + containerWidth
        ) {
          container.scrollLeft =
            offsetLeft + activeItem.offsetWidth - containerWidth
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.tags-view-container {
  display: flex;
  align-items: stretch;
  height: 54px;
  background: #F8F9FA;
  flex-shrink: 0;
  padding: 8px 12px 0 12px;
}

.tags-view-wrapper {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;

  :deep(.el-scrollbar__wrap) {
    overflow-x: auto;
    overflow-y: hidden !important;
    height: 54px;
  }

  :deep(.el-scrollbar__bar.is-vertical) {
    display: none !important;
  }

  :deep(.el-scrollbar__view) {
    display: flex;
    align-items: flex-end;
    height: 54px;
  }
}

.tags-view-item {
  display: inline-flex;
  align-items: center;
  height: 46px;
  line-height: 46px;
  padding: 0 28px;
  border-radius: 10px 10px 0 0;
  font-size: 14px;
  color: #909399;
  background: #EBECEF;
  border: 1px solid #DEE0E3;
  border-bottom: none;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.15s;
  user-select: none;
  position: relative;
  margin-right: 1px;

  &:hover {
    color: #303133;
    background: #E3E5E8;
    border-color: #D0D3D7;
  }

  &.active {
    color: #1661f7;
    background: #F2F3F5;
    border-color: #D9DBDF;
    border-bottom: none;
    border-radius: 10px 10px 0 0;
    font-weight: 500;
    z-index: 1;

    &::before {
      content: '';
      position: absolute;
      bottom: 0;
      left: -1px;
      width: 5px;
      height: 5px;
      background: #F8F9FA;
      border-radius: 0 0 5px 0;
      border-right: 1px solid #D9DBDF;
      border-bottom: 1px solid #D9DBDF;
    }

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      right: -1px;
      width: 5px;
      height: 5px;
      background: #F8F9FA;
      border-radius: 0 0 0 5px;
      border-left: 1px solid #D9DBDF;
      border-bottom: 1px solid #D9DBDF;
    }

    .tags-view-item-close {
      color: #909399;

      &:hover {
        color: #fff;
        background: #c0c4cc;
      }
    }

    .tags-view-item-title {
      padding-right: 10px;
    }
  }

  .tags-view-item-title {
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-right: 4px;
  }

  .tags-view-item-close {
    position: absolute;
    top: 6px;
    right: 6px;
    width: 16px;
    height: 16px;
    line-height: 16px;
    text-align: center;
    font-size: 10px;
    border-radius: 50%;
    flex-shrink: 0;
    opacity: 0;
    transition: opacity 0.15s;
  }

  &:hover .tags-view-item-close {
    opacity: 1;
  }

  &.active .tags-view-item-close {
    opacity: 1;
  }
}

.tags-view-actions {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  padding: 0 4px 6px 4px;
}

.tags-view-dropdown {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  cursor: pointer;
  border-radius: 4px;
  color: #909399;
  font-size: 13px;

  &:hover {
    background: #E3E5E8;
    color: #303133;
  }
}
</style>
